import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { buildTimeline } from '@/components/investigations/InvestigationDossier'
import { api } from '@/services/api'
import type { GraphNoteItem } from '@/services/api/graph'
import type { Investigation } from '@/types/investigation'

/** Builds the investigation's notes timeline, merging the PostgreSQL `inv.notes`
 *  with case-wide Neo4j `:Note` nodes (graph notes from the canvas ring-menu)
 *  so freshly-created graph notes surface here too. */
export function useInvestigationTimeline(inv: Investigation) {
  const graphNotesQuery = useQuery({
    queryKey: ['case-graph-notes', inv.caseId],
    queryFn: () => api.graph.getNotesAndFindings(inv.caseId),
    enabled: Boolean(inv.caseId),
    staleTime: 30_000,
  })

  const graphNotes = useMemo<GraphNoteItem[]>(() => {
    const items = graphNotesQuery.data?.items ?? []
    return items.filter((it): it is GraphNoteItem => it.type === 'note')
  }, [graphNotesQuery.data])

  return useMemo(() => buildTimeline(inv, graphNotes), [inv, graphNotes])
}
